import { createSelector } from 'reselect'
import { getSharedFacetNames } from 'selectors/algolia2/data'
import { getPathParams, getPageParamsQuery } from './app'

/*
AllFacets - Algolia non filtered facet results ( all possible facets )
AlgoliaFacets - Algolia facets available after a query
SelectedFacets - Current Facets selected, used for building URL and Tracking changes
*/
export const getAlgolia = (state: Record<string, any>): Record<string, any> => state.algolia || {}

export const getSelectedFacets = createSelector(
  getAlgolia,
  (pageData): Record<string, any> => {
    return pageData.selectedFacets || {}
  }
)

export const getSlugifyDictionary = createSelector(
  getAlgolia,
  (pageData): Record<string, any> => pageData.slugifyDictionary || {}
)

export const getSelectedFacetsCount = createSelector(
  getSelectedFacets,
  (selectedFacets): number =>
    Object.entries(selectedFacets).reduce((count, [facetName, attributes]) => {
      // Only track count for these FACETS
      if (facetName.search(/category|original_status|size|price|orientation/) > -1) {
        let itemCount = 0

        if (Array.isArray(attributes)) {
          itemCount = attributes.length
        } else if (attributes) {
          itemCount = 1
        }

        return count + itemCount
      }

      return count
    }, 0) || 0
)
export const getSelectedFacetNameAttributes = (facetName: string) =>
  createSelector(
    getSelectedFacets,
    (selectedFacets): Array<string> => {
      const currentValues = selectedFacets[facetName] || []
      // We always want to work with an ARRAY to FILTER
      return Array.isArray(currentValues) ? currentValues : [currentValues]
    }
  )
// Used to Know whether a Facet should be added or removed
export const doesSelectedFacetNameAttributeExist = (facetName: string, attributeValue: string) =>
  createSelector(
    getSelectedFacetNameAttributes(facetName),
    (facetAttributes): boolean => facetAttributes.includes(attributeValue) || false
  )
export const updateFacetValues = (facetName: string, attributeValue: string) =>
  createSelector(
    getSelectedFacetNameAttributes(facetName),
    doesSelectedFacetNameAttributeExist(facetName, attributeValue),
    (selectedFacetNameValues, facetNameAttributeExist): Array<string> =>
      facetNameAttributeExist && Array.isArray(selectedFacetNameValues)
        ? [...selectedFacetNameValues.filter((attr) => attr !== attributeValue)] // REMOVE AttributeValue
        : [...selectedFacetNameValues, attributeValue] // ADD AttributeValue}
  )
// We gather all DATA needed to create the URL using the HELPER => generateLocationUrl({ queryParams, pathParams, sharedFacetNames })
export const getParamsToGenerateURL = createSelector(
  [getSelectedFacets, getPageParamsQuery, getPathParams, getSharedFacetNames],
  (selectedFacets, pageParams, pathParams, sharedFacetNames): Record<string, any> => {
    return {
      queryParams: { ...selectedFacets, ...pageParams },
      pathParams,
      sharedFacetNames,
    }
  }
)
